import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

const button = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-transparent font-ui font-semibold tracking-tight transition-colors focus:outline-none focus-visible:[box-shadow:var(--focus-ring)] disabled:pointer-events-none disabled:opacity-45',
  {
    variants: {
      variant: {
        primary: 'bg-brand text-brand-ink shadow-flat hover:bg-brand-deep',
        secondary: 'border-line-2 bg-surface text-fg hover:bg-surface-2',
        ghost: 'text-fg-dim hover:bg-surface-2 hover:text-fg',
        danger: 'border-error-border bg-error-bg text-error-ink hover:brightness-95',
        success: 'border-success-border bg-success-bg text-success-ink hover:brightness-95',
      },
      size: {
        sm: 'h-8 gap-1.5 px-3 text-[12.5px]',
        md: 'h-9 px-4 text-[13.5px]',
      },
      full: { true: 'w-full' },
    },
    defaultVariants: { variant: 'secondary', size: 'md' },
  },
);

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof button> {}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant, size, full, ...props },
  ref,
) {
  return <button ref={ref} className={cn(button({ variant, size, full }), className)} {...props} />;
});
